const load = (elementId: string): string => {
    const element = document.getElementById(elementId);
    if (element && element.hasAttribute('data-base-href')) return element.getAttribute('data-base-href');
    return '';
};

export const baseHrefService = {
    load,
};
